import React, { useState } from 'react';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import ru from 'date-fns/locale/ru';
import { FormGroupLabel } from './common/FormGroupLabel';
import classNames from 'classnames';
import moment from 'moment';
import { COLORS, Icon } from '../../index';
import { acCalendar } from 'ac-icon';
import { isEmpty } from 'ac-share';
registerLocale('ru', ru);
const DatePicker = ({ id, name, label, placeholder, value, minDate, maxDate, valid, feedback, required, disabled, onChange, className, popperPlacement, withIcon, showTimeSelect, showYearDropdown = true, showMonthDropdown = true, helpText, monthsShown, selectsRange, startDate, endDate, onClickOutsideAdditional, feedbackClassName, isShowRequired, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const getMaxDate = (newMaxDate) => {
        if (newMaxDate) {
            return newMaxDate;
        }
        else {
            const date = new Date();
            return new Date(date.setMonth(date.getMonth() + 12));
        }
    };
    let newValue;
    if (value === 0 || value === null || value === undefined) {
        newValue = null;
    }
    else {
        newValue = new Date(value);
    }
    const css = classNames('ac-input ', {
        'with-icon': withIcon,
    });
    moment.locale('ru');
    return (React.createElement(FormGroupLabel, { label: label, valid: valid, feedback: feedback, className: className, isShowRequired: !isEmpty(isShowRequired) ? isShowRequired : required, helpText: helpText, feedbackClassName: feedbackClassName },
        React.createElement("div", { className: 'd-flex flex-row align-items-center w-100 datepicker-wrapper' },
            React.createElement(ReactDatePicker, { selectsRange: selectsRange, startDate: startDate, endDate: endDate, fixedHeight: true, monthsShown: monthsShown ? monthsShown : 1, id: id, value: newValue, open: isOpen, disabledKeyboardNavigation: true, name: name, selected: newValue, calendarStartDay: 1, dateFormat: 'dd.MM.yyyy', required: required, disabled: disabled, showMonthDropdown: showMonthDropdown, showYearDropdown: showYearDropdown, showPopperArrow: false, showTimeSelect: showTimeSelect, popperProps: { positionFixed: true }, locale: 'ru', className: css, placeholderText: placeholder, onClickOutside: () => {
                    setIsOpen(false);
                    if (onClickOutsideAdditional) {
                        onClickOutsideAdditional();
                    }
                }, onInputClick: () => {
                    setIsOpen(true);
                }, onFocus: (e) => {
                    e.stopPropagation();
                }, autoComplete: 'off', popperPlacement: popperPlacement, popperClassName: 'ac-react-datepicker-popover', popperModifiers: [
                    {
                        name: 'preventOverflow',
                        options: {
                            // rootBoundary: 'viewport',
                            tether: false,
                            altAxis: false,
                        },
                    },
                ], dropdownMode: 'scroll', scrollableYearDropdown: true, yearDropdownItemNumber: 50, inline: false, minDate: minDate, maxDate: getMaxDate(maxDate), onChange: selectsRange
                    ? (dates) => {
                        onChange(dates);
                        if (dates[1]) {
                            setIsOpen(false);
                        }
                    }
                    : (date) => {
                        onChange(date);
                        setIsOpen(false);
                    } }),
            withIcon && (React.createElement("div", { className: 'd-flex', onClick: (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    setIsOpen(true);
                } },
                React.createElement(Icon, { path: acCalendar, className: 'datepicker-icon ' + (label ? 'with-label ' : ''), size: '20px', color: isOpen ? COLORS.primitiveNavyBlue : undefined, opacity: isOpen ? 0.88 : undefined, title: undefined }))))));
};
export { DatePicker };
//# sourceMappingURL=DatePicker.js.map